import React, { useState } from "react";
import { ROWS, COLS, PIECE } from "./utils/c4Logic";
import ConnectFourCell from "./ConnectFourCell";

export default function ConnectFourBoard({
  board,
  winCells,
  myPiece,
  currentTurn,
  isGameOver,
  isDisabled,
  lastDrop,
  onColumnClick,
  maxWidthStyle,
}) {
  const [hoveredCol, setHoveredCol] = useState(null);

  if (!board) return null;

  const winSet = new Set(
    (winCells ?? []).map(([r, c]) => r * COLS + c)
  );

  const canInteract = !isDisabled && !isGameOver && currentTurn === myPiece;

  return (
    <div
      className="relative w-full shrink-0 overflow-hidden rounded-[30px] border border-black/70 bg-[linear-gradient(145deg,#111827,#030607_58%,#010203)] p-2.5 shadow-[0_30px_90px_rgba(0,0,0,0.68),inset_0_1px_0_rgba(255,255,255,0.075),inset_0_-18px_32px_rgba(0,0,0,0.42)] mx-auto select-none"
      style={{ maxWidth: maxWidthStyle || "min(92vw, 640px)" }}
    >
      <div className="pointer-events-none absolute inset-x-8 top-0 z-10 h-px bg-gradient-to-r from-transparent via-white/18 to-transparent" />
      <div className="pointer-events-none absolute inset-0 z-10 rounded-[30px] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.035),inset_0_16px_36px_rgba(255,255,255,0.035),inset_0_-22px_42px_rgba(0,0,0,0.48)]" />
      <div
        className="relative grid overflow-hidden rounded-[21px] border border-black/70 bg-[#030607] p-1.5 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.035),0_12px_28px_rgba(0,0,0,0.45)]"
        style={{ gridTemplateColumns: `repeat(${COLS}, 1fr)` }}
      >
        {Array.from({ length: ROWS }, (_, row) =>
          Array.from({ length: COLS }, (_, col) => {
            const idx = row * COLS + col;
            return (
              <ConnectFourCell
                key={idx}
                piece={board[idx] ?? PIECE.NONE}
                isWinCell={winSet.has(idx)}
                isHovered={hoveredCol === col && row === 0 && board[idx] === PIECE.NONE}
                hoverPiece={currentTurn}
                isLastDrop={lastDrop?.row === row && lastDrop?.col === col}
              />
            );
          })
        )}

        <div
          className="absolute inset-0 grid"
          style={{ gridTemplateColumns: `repeat(${COLS}, 1fr)` }}
        >
          {Array.from({ length: COLS }, (_, col) => (
            <button
              key={`col-${col}`}
              type="button"
              disabled={!canInteract}
              aria-label={`Drop piece in column ${col + 1}`}
              onClick={() => canInteract && onColumnClick(col)}
              onMouseEnter={() => setHoveredCol(col)}
              onMouseLeave={() => setHoveredCol(null)}
              className="
                relative h-full min-h-full rounded-md
                focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C6A15B]/70
                cursor-pointer disabled:cursor-default
              "
            >
              {canInteract && hoveredCol === col && (
                <span
                  className="absolute left-1/2 top-1 -translate-x-1/2 w-3 h-3 rounded-full"
                  style={{
                    background: currentTurn === PIECE.ONE ? "#356da4" : "#8f1212",
                    border: "1px solid rgba(2,6,8,0.72)",
                    boxShadow: currentTurn === PIECE.ONE
                      ? "0 0 16px rgba(53,109,164,0.28)"
                      : "0 0 16px rgba(143,18,18,0.30)",
                    opacity: 0.9,
                  }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
